/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';


if ( TARGET === 'android-stb' || TARGET === 'android-app' ) {
    module.exports = {
        record: 'theme-icon theme-icon-play',
        play: 'theme-icon theme-icon-play',
        favorite: 'theme-icon theme-icon-favorite',
        favoriteActive: 'theme-icon theme-icon-favorite-active active',
        tvGuide: 'theme-icon theme-icon-menu'
    };
} else {
    module.exports = {
        record: 'theme-icon theme-icon-rc-f1',
        play: 'theme-icon theme-icon-rc-f2',
        favorite: 'theme-icon theme-icon-rc-f3',
        favoriteActive: 'theme-icon theme-icon-rc-f3',
        tvGuide: 'theme-icon theme-icon-rc-f4'
    };
}
